import styled from '@emotion/styled';

const Description = styled('span')(({ theme }) => ({
  fontSize: theme.fonts.size.small,
  width: '10rem',
}));

export default Description;
